/**
* Created by bieao on 2020/4/2.
*/
<template>
  <div>
    <div class="item-position title-item">
      <div class="first"></div>
      <div class="two">05</div>
      <div class="title">
        <div>Today's Alarm Ranking</div>
        <div>今日报警排名</div>
      </div>
    </div>
    <div class="item-position statistics-chart">
      <div class="chart-item">
        <div>报警</div>
        <div id="alarm"></div>
      </div>
      <div class="chart-item">
        <div>违章</div>
        <div id="peccancy"></div>
      </div>
    </div>
  </div>
</template>

<script>
import G2 from '@antv/g2'
export default {
  name: 'StatisticsChart',
  data () {
    return {
      alarmChart: null,
      peccancyChart: null
    }
  },
  props: {
    alarmData: {
      type: Array
    },
    peccancyData: {
      type: Array
    }
  },
  watch: {
    alarmData (val, oldVal) {
      if (val !== oldVal) {
        this.alarmChart.source(val)
        this.alarmChart.repaint()
      }
    },
    peccancyData (val, oldVal) {
      if (val !== oldVal) {
        this.peccancyChart.source(val)
        this.peccancyChart.repaint()
      }
    }
  },
  methods: {
    initAlarmChart () {
      this.alarmChart = new G2.Chart({
        container: 'alarm',
        forceFit: true,
        height: 300,
        width: 210,
        padding: [0, 22, 0, 30]
      })
      this.alarmChart.axis('title', {
        label: {
          offset: 5,
          textStyle: {
            fill: '#ffffff',
            fontSize: 11
          }
        },
        tickLine: false,
        line: {
          stroke: '#165e75'
        }
      })
      this.alarmChart.axis('total', false)
      this.alarmChart.coord().transpose()
      this.alarmChart.interval().position('title*total').color('title', ['#1d7490']).size(10)
        .opacity(0.5)
        .label('total', {
          offset: 2,
          textStyle: {
            fill: '#49d5f3'
          }
        })
      this.alarmChart.render()
    },
    initPeccancyChart () {
      this.peccancyChart = new G2.Chart({
        container: 'peccancy',
        forceFit: true,
        height: 300,
        width: 210,
        padding: [0, 22, 0, 30]
      })
      this.peccancyChart.axis('title', {
        label: {
          offset: 5,
          textStyle: {
            fill: '#ffffff',
            fontSize: 11
          }
        },
        tickLine: false,
        line: {
          stroke: '#165e75'
        }
      })
      this.peccancyChart.axis('total', false)
      this.peccancyChart.coord().transpose()
      this.peccancyChart.interval().position('title*total').color('title', ['#1d7490']).size(10)
        .opacity(0.5)
        .label('total', {
          offset: 2,
          textStyle: {
            fill: '#49d5f3'
          }
        })
      this.peccancyChart.render()
    }
  },
  mounted () {
    this.initAlarmChart()
    this.initPeccancyChart()
  }
}
</script>

<style scoped lang="scss">
  .title-item{
    left: 1510px;
    top: 480px;
  }
  .statistics-chart{
    left: 1488px;
    top: 518px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    .chart-item{
      display: flex;
      align-items: center;
      font-size: 13px;
      color:#ffffff;
      div:first-child{
        display: flex;
        flex-direction: column;
        width:20px;
      }
      #alarm{
        height:300px;
        width:210px;
      }
      #peccancy{
        height:300px;
        width:170px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/StatisticsChart.vue